import React from "react"
import { HeroSection, InformationSection, MenuSection } from "./components"

const ThucDonTanDinh: React.FC = () => {
  return (
    <>
      <HeroSection />
      <div
        className="w-full bg-cover bg-no-repeat"
        style={{ backgroundImage: "url('/background-img.jpg')" }}
      >
        <InformationSection />
        <MenuSection />
      </div>
    </>
  )
}

export default ThucDonTanDinh
